import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const ProductSelect = ({ title, defaultValue = null, handler, id = null }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectProduct") : title;
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const handleChange = (e) => {
    setSelectedProduct(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getProducts = async () => {
    try {
      const response = await apiService.get(`api/v1/products/store/${storeId}`);
      const activeProducts = response.filter((el) => !el.deleted);
      const availableProducts = activeProducts.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setProducts(availableProducts);
      if (id) {
        availableProducts.map((o) => {
          if (o.value == id) {
            o.isDisabled = true;
            return o;
          }
        });
      }
      setNewValue(null);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedProduct = products.find((el) => el.value === defaultValue);
    if (selectedProduct) setSelectedProduct(selectedProduct);
  };

  useEffect(() => {
    if (!storeId) return;
    getProducts();
  }, [storeId]);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="productSelect"
          onChange={handleChange}
          value={selectedProduct}
          options={products}
          noOptionsMessage={() => t("messages.noProductsAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default ProductSelect;
